import { Sparkles, CalendarCheck, Compass } from "lucide-react";

// Display metadata for the three onboarding feature indicators (keys match the backend).
export const AREAS = {
  future_self: {
    label: "Future Self Engine™", name: "Future Self", Icon: Sparkles,
    about: "Imagine having a conversation with a future version of yourself — someone who has already reached the goals you're working toward. Your Future Self can help you explore possibilities, gain perspective, and discover your next steps.",
    color: "#0891B2", tint: "rgba(8,145,178,0.12)", glow: "rgba(6,182,212,0.45)",
    explore: "Explore the person you're working toward becoming.",
  },
  battle_plan: {
    label: "Daily Battle Plan™", name: "Daily Battle Plan", Icon: CalendarCheck,
    about: "Turn what you're experiencing into a personalized plan for today. Ellie helps you identify three meaningful things to focus on and one challenge to watch out for.",
    color: "#0D9488", tint: "rgba(13,148,136,0.12)", glow: "rgba(13,148,136,0.45)",
    explore: "Turn what we're learning into practical steps you can take.",
  },
  purpose: {
    label: "Purpose Engine™", name: "Purpose Engine", Icon: Compass,
    about: "Explore what gives your life meaning, discover what truly matters to you, and begin connecting your everyday choices to a bigger sense of direction.",
    color: "#7C3AED", tint: "rgba(124,58,237,0.11)", glow: "rgba(139,92,246,0.45)",
    explore: "Discover more about what matters most to you.",
  },
};

export const AREA_ORDER = ["future_self", "battle_plan", "purpose"];
